'use client';

import { cn } from '@/lib/utils';
import { Media } from '@/components/ui/media/media';
import type { MediaData } from '@/lib/getMediaData';
import React, { useContext } from 'react';
import styles from './slide.module.scss';
import { SliderContext } from './Slider';

export type SlideProps = {
  stars?: string | null;
  media?: MediaData;
  children?: React.ReactNode;
};

function printStars(stars: string) {
  const count = parseInt(stars, 10);
  if (isNaN(count) || count <= 0) return null;

  return (
    <div className={styles.stars}>
      {Array.from({ length: count }).map((_, i) => (
        <img key={i} src="/images/star.svg" alt="star" className={styles.star} />
      ))}
    </div>
  );
}

export const Slide = ({ stars, media, children }: SlideProps) => {
  const sliderContext = useContext(SliderContext);

  if (!sliderContext) {
    return (
      <div className={cn(styles.warning)}>
        <h5>Remove this instance!</h5>
        <p>
          This component must be placed inside a <strong>Slider component</strong>.
        </p>
      </div>
    );
  }

  const hasMedia = media && media.mediaType !== undefined;

  return (
    <div className={styles.slideSpace}>
      <div className={styles.slideWrapper}>
        <div className={cn(styles.slideInner, hasMedia && styles.slideInner__withMedia)}>
          {hasMedia && (
            <div className={styles.slideMedia}>
              <Media {...media} />
            </div>
          )}
          {stars ? printStars(stars) : null}
          {children}
        </div>
      </div>
    </div>
  );
};
